<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="orderInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="代理等级" >
						<el-select v-model="orderInfo.agentLevel" placeholder="请选择">
							<el-option key="-1" label="全部" value="">全部</el-option>

							<el-option key="1" label="省代" :value="1">省代</el-option>
							<el-option key="2" label="市代" :value="2">市代</el-option>
							<el-option key="3" label="区代" :value="3">区代</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="区域名称" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.areaName" placeholder="请输入区域名称"></el-input>
					</el-form-item>
					<el-form-item label="UID" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.userId" placeholder="请输入UID"></el-input>
					</el-form-item>
					<el-form-item label="用户名" class='tiny'>
						<el-input style="width:300px;" v-model="orderInfo.username" placeholder="请输入用户名"></el-input>
					</el-form-item>
					<el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="orderInfo.phone" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="orderInfo.timer" value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
								start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile">导出</el-button> -->
						</template>
					</el-form-item>

				</el-form>

			</header>

		</div>
		<!-- 列表展示 -->
		<el-table :data="userAreaLists" stripe>
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="120px">
						<el-form-item label="商城订单">
							<span>￥{{ props.row.shopGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.shopOrderCnt }}笔</span>
						</el-form-item>
						<el-form-item label="客户回馈让利">
							<span>￥{{ props.row.hkRl }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.hkOrderCnt }}笔</span>
						</el-form-item>
					
						<el-form-item label="门店订单">
							<span>￥{{ props.row.storeGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.storeCnt }}笔</span>
						</el-form-item>
						<el-form-item label="门店让利">
							<span>￥{{ props.row.storeRl }}</span>
						</el-form-item>

					
						<el-form-item label="扫码收款">
							<span>￥{{ props.row.scanPayGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.scanPayCnt }}笔</span>
						</el-form-item>
						<el-form-item label="扫码让利">
							<span>￥{{ props.row.scanPayRl }}</span>
						</el-form-item>

						<!-- <el-form-item label="客户回馈">
							<span>￥{{ props.row.hkGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.hkOrderCnt }}笔</span>
						</el-form-item> -->
						
					
						<el-form-item label="收银台流水">
							<span>￥{{ props.row.sytGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.sytOrderCnt }}笔</span>
						</el-form-item>
						<el-form-item label="收银台让利">
							<span>￥{{ props.row.sytRl }}</span>
						</el-form-item>
					
						<el-form-item label="卡项">
							<span>￥{{ props.row.kxGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.kxCnt }}笔</span>
						</el-form-item>
						<el-form-item label="卡项让利">
							<span>￥{{ props.row.kxRl }}</span>
						</el-form-item>
					
						<el-form-item label="云连锁核销">
							<span>￥{{ props.row.ylsGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.ylsOrderCnt }}笔</span>
						</el-form-item>
						<el-form-item label="云连锁核销实收">
							<span>￥{{ props.row.ylsSh }}</span>
						</el-form-item>

						<el-form-item label="采购订单">
							<span>￥{{ props.row.caigouGmv }}</span>
							<span style="margin:0 10px;">|</span>
							<span>{{ props.row.caigouOrderCnt }}笔</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="logo" label="用户头像" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<img :src="scope.row.logo" alt="" style="width:50px;height:50px;">

				</template>
			</el-table-column>
			<el-table-column prop="userId" label="UID" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="username" label="用户名" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="provinceName" label="所属省" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="cityName" label="所属市" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.cityName==null">无</span>
					<span v-else>{{scope.row.cityName}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="areaName" label="所属区" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.areaName==null">无</span>
					<span v-else>{{scope.row.areaName}}</span>
				</template>
			</el-table-column>
			<el-table-column prop="agentLevel" label="代理等级" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.agentLevel==1">省代理</span>
					<span v-if="scope.row.agentLevel==2">市代理</span>
					<span v-if="scope.row.agentLevel==3">区代理</span>
				</template>
			</el-table-column>
			<!-- <el-table-column prop="userLevel" label="会员等级" align="center" width="" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<span v-if="scope.row.userLevel == '0'">会员</span>
					<span v-if="scope.row.userLevel == '1'">小超</span>
					<span v-if="scope.row.userLevel == '2'">经理</span>
					<span v-if="scope.row.userLevel == '3'">县代</span>
					<span v-if="scope.row.userLevel == '4'">区代</span>
					<span v-if="scope.row.userLevel == '5'">市代</span>
					<span v-if="scope.row.userLevel == '6'">省代</span>
					<span v-if="scope.row.userLevel == '7'">运营中心</span>
				</template>
			</el-table-column> -->
			<el-table-column prop="createTime" label="创建时间" align="center" width="" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop=""  label="操作"  fixed="right" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<el-button size="small" type="text" @click="editialogVisible(scope.row.id,scope.row.agentLevel)">编辑
					</el-button>
					<el-button size="small" type="text" @click="delitialogVisible(scope.row.id)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination background :current-page="expressList.pageNum" @current-change="pageChange"
			layout="total, sizes, prev, pager, next, jumper" :total="expressList.total" @size-change="handleSizeChange">
		</el-pagination>
		<!-- 编辑修改 -->
		<!-- clearable filterable -->
		<el-dialog :visible.sync="dialogVisibleSwipers" title="编辑修改" @close="addDialogClose" :close-on-click-modal="false">
			<div style="text-align: center">
				<el-form>

					<el-form-item label="代理类型:" label-width="150px">
						<el-select v-model="proxy.agentLevel" placeholder="请选择" @change="chooseLevel">
							<!-- <el-option key="0" label="无" :value="0">无</el-option> -->
							<el-option key="1" label="省代" :value="1">省代</el-option>
							<el-option key="2" label="市代" :value="2">市代</el-option>
							<el-option key="3" label="区代" :value="3">区代</el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="省:" label-width="150px"
						v-if="proxy.agentLevel==1 || proxy.agentLevel==2 || proxy.agentLevel==3">
						<el-select clearable filterable v-model="provinceId" placeholder="请选择省" @change="provinceFocus">
							<el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="市:" label-width="150px" v-if="proxy.agentLevel==2 || proxy.agentLevel==3">
						<el-select clearable filterable v-model="cityId" placeholder="请选择市" @change="cityFcus">
							<el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="区:" label-width="150px" v-if="proxy.agentLevel==3">
						<el-select clearable filterable v-model="areaId" placeholder="请选择区" @change="districtFcus">
							<el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.id">
							</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="是否启用" class="redItem">
			<el-switch v-model="orderInfo.status" :active-value="true" :inactive-value="false" class="switchss">
		</el-switch>
	</el-form-item> -->

					<el-button type="primary" @click="submitClick" :loading="submitClickLoading">提交</el-button>

				</el-form>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				page: {
					pageNum: 1,
					pageSize: 10,
				},
				userAreaLists: [],
				expressList: {},
				storeGoodsInfo: {},
				dialogVisibleSwipers: false,
				orderInfo: {
					agentLevel: ''
				},
				provinceList: {},
				cityList: {},
				districtList: {},
				id: '',
				proxy: {

				},
				provinceId: 0,
				cityId: 0,
				areaId: 0,

				submitClickLoading: false,
			}
		},
		methods: {
			search() { //查询
				this.page.pageNum = 1;
				this.userAreaList()
			},
			empty() { //清空
				this.orderInfo = {}
			},
			downloadFile() { //导出
				let data = {
					// pageNum: this.page.pageNum, 
					// pageSize: this.page.pageSize,
					// areaName: this.orderInfo.areaName,
					...this.orderInfo,
					// username: this.orderInfo.username,
					startTime: this.orderInfo.timer ? this.orderInfo.timer[0] : "",
					endTime: this.orderInfo.timer ? this.orderInfo.timer[1] : "",
				};
				//   console.log(data);
				this.$api.agencyExcel(data).then((res) => {
					console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "代理管理" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			addDialogClose() {
				this.dialogVisibleSwipers = false
			},
			userAreaList() {
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					// areaName: this.orderInfo.areaName,
					...this.orderInfo,
					// username: this.orderInfo.username,
					startTime: this.orderInfo.timer ? this.orderInfo.timer[0] : "",
					endTime: this.orderInfo.timer ? this.orderInfo.timer[1] : "",
				}
				console.log(data)
				this.$api.userAreaList(data).then((res) => {
					console.log(res)
					if (res.state == 'success') {
						this.userAreaLists = res.data.list
						this.expressList = res.data
					}
				})
			},
			// 删除
			delitialogVisible(e) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.delUserAreaInfo(e).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.userAreaList()
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消'
					});
				});


			},
			// 编辑修改
			editialogVisible(e) {
				console.log(e);
				this.proxy = {}
				this.provinceId = ''
				this.cityId = ''
				this.areaId = ''

				this.id = e
				this.$api.findUserAreaInfo(e).then((res) => {
					if (res.state == 'success') {
						this.proxy = res.data
						this.provinceId = res.data.provinceId
						this.cityId = res.data.cityId
						this.areaId = res.data.areaId
						console.log(res)

						if (res.data.agentLevel && res.data.agentLevel == 3) {
							//市
							this.$api.getAreasFive(res.data.provinceId).then((res) => {
								if (res.state == 'success') {
									this.cityList = res.data
								}
							})

							//区
							this.$api.getAreasFive(res.data.cityId).then((res) => {
								if (res.state == 'success') {
									this.districtList = res.data
								}
							})
							console.log(this.districtList)
						} else if (res.data.agentLevel && res.data.agentLevel == 2) {
							//市
							this.$api.getAreasFive(res.data.provinceId).then((res) => {
								if (res.state == 'success') {
									this.cityList = res.data
								}
							})
						}

					}
				})
				this.dialogVisibleSwipers = true
			},

			//修改提交
			submitClick() {
				this.submitClickLoading = true;
				let data = {
					id: this.proxy.id,
					agentLevel: this.proxy.agentLevel,
				}
				if (data.agentLevel == 3) {
					data.areaId = this.proxy.areaId;
				} else if (data.agentLevel == 2) {
					data.areaId = this.cityId;
				} else if (data.agentLevel == 1) {
					data.areaId = this.provinceId;
				}
				this.$api.editUserAreaList(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.dialogVisibleSwipers = false
						this.userAreaList()
						this.orderInfo = {}
					} else {
						this.$message.error(res.message);
					}
					this.submitClickLoading = false;
				})


			},
			//选择代理级别查询对用省市区数据
			chooseLevel(e) {
				console.log(e)
				if (e == 3 && this.cityId) {
					this.cityFcus(this.cityId)
				}
			},
			//查询市
			provinceFocus(e) {
				this.proxy.areaId = null;
				this.provinceId = e;
				this.cityId = '';
				this.areaId = '';
				this.cityList = {}
				this.districtList = {}

				/* let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				}); */

				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
						}
					})
				}
			},
			//查询区
			cityFcus(e) {
				console.log(e)

				this.proxy.areaId = null;
				this.cityId = e;
				this.areaId = '';
				this.districtList = {}

				/* let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				}); */

				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data

						}
					})
				}

			},
			districtFcus(e) {
				this.proxy.areaId = e;
				/*let obj = {};
				 obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				}); */
			},

			pageChange(data) {
				this.page.pageNum = data
				this.userAreaList();
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.userAreaList()
			},

		},
		created() {
			this.userAreaList()

			//查询省
			this.$api.getAreasFive(0).then((res) => {
				// console.log(res)
				if (res.state == 'success') {
					this.provinceList = res.data
				}
			})
		}

	}
</script>

<style>
	.el-pagination.is-background {
		margin-left: 30px;
		padding: 40px 0;
	}
</style>